import request from "@/network/request"

// 查询食堂和订单列表
export function requestOrderList(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsideHome/home`,
    method: 'post',
    data
  });
}
// 获取餐品列表
export function requestMealList(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsideOrder/home`,
    method: 'post',
    data
  });
}
// 购物车支付
export function submitOrder(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsidePay/submitOrder`,
    method: 'post',
    data
  });
}

// 订餐订单列表
export function orderPage(data) {
  return request({
    url: `/hospitalordering/applet/order/order/page`,
    method: 'post',
    data
  });
}

// 订餐订单详情
export function orderDetails(data) {
  return request({
    url: `/hospitalordering/applet/order/order/info`,
    method: 'post',
    data
  });
}
// 获取食堂配制
export function canteenSetting(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsideHome/canteenSetting`,
    method: 'post',
    data
  });
}
// 预定列表
export function bedsideBook(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsideBook/home`,
    method: 'post',
    data
  });
}

// 预定点击tap的列表
export function reserveList(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsideBook/dishList`,
    method: 'post',
    data
  });
}
// 餐品详情
export function mealsDetails(data) {
  return request({
    url: `/hospitalordering/applet/bedside/bedsideHome/dishInfo`,
    method: 'post',
    data
  });
}